const nutrientDB = {
  "Green Beans (cooked)": {
    "Calories (kcal)": 35.0,
    "Protein (g)": 1.9,
    "Fat (g)": 0.2,
    "Fibre (g)": 3.2,
    "Carbohydrate (g)": 7.9,
    "Moisture (%)": 89.3,
    "Calcium (mg)": 37.0,
    "Phosphorus (mg)": 38.0,
    "Magnesium (mg)": 25.0,
    "Sodium (mg)": 6.0,
    "Potassium (mg)": 209.0,
    "Iron (mg)": 1.0,
    "Zinc (mg)": 0.2,
    "Copper (mg)": 0.08,
    "Vitamin A (IU)": 759.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 0.4,
    "Thiamine (B1) (mg)": 0.06,
    "Riboflavin (B2) (mg)": 0.11,
    "Niacin (B3) (mg)": 0.7,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 0.02,
    "Alpha-Linolenic Acid (g)": 0.03,
    "EPA + DHA (g)": 0.0
  },
  "Pumpkin (cooked)": {
    "Calories (kcal)": 20.0,
    "Protein (g)": 0.7,
    "Fat (g)": 0.1,
    "Fibre (g)": 0.5,
    "Carbohydrate (g)": 6.5,
    "Moisture (%)": 91.6,
    "Calcium (mg)": 21.0,
    "Phosphorus (mg)": 16.0,
    "Magnesium (mg)": 12.0,
    "Sodium (mg)": 1.0,
    "Potassium (mg)": 230.0,
    "Iron (mg)": 0.8,
    "Zinc (mg)": 0.2,
    "Copper (mg)": 0.05,
    "Vitamin A (IU)": 8510.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 1.1,
    "Thiamine (B1) (mg)": 0.03,
    "Riboflavin (B2) (mg)": 0.05,
    "Niacin (B3) (mg)": 0.6,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 0.01,
    "Alpha-Linolenic Acid (g)": 0.03,
    "EPA + DHA (g)": 0.0
  },
  "Banana (ripe)": {
    "Calories (kcal)": 89.0,
    "Protein (g)": 1.1,
    "Fat (g)": 0.3,
    "Fibre (g)": 2.6,
    "Carbohydrate (g)": 22.8,
    "Moisture (%)": 74.9,
    "Calcium (mg)": 5.0,
    "Phosphorus (mg)": 22.0,
    "Magnesium (mg)": 27.0,
    "Sodium (mg)": 1.0,
    "Potassium (mg)": 358.0,
    "Iron (mg)": 0.3,
    "Zinc (mg)": 0.2,
    "Copper (mg)": 0.08,
    "Vitamin A (IU)": 64.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 0.1,
    "Thiamine (B1) (mg)": 0.03,
    "Riboflavin (B2) (mg)": 0.07,
    "Niacin (B3) (mg)": 0.7,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 0.01,
    "Alpha-Linolenic Acid (g)": 0.03,
    "EPA + DHA (g)": 0.0
  },
  "Apple (raw)": {
    "Calories (kcal)": 52.0,
    "Protein (g)": 0.3,
    "Fat (g)": 0.2,
    "Fibre (g)": 2.4,
    "Carbohydrate (g)": 13.8,
    "Moisture (%)": 85.6,
    "Calcium (mg)": 6.0,
    "Phosphorus (mg)": 11.0,
    "Magnesium (mg)": 5.0,
    "Sodium (mg)": 1.0,
    "Potassium (mg)": 107.0,
    "Iron (mg)": 0.1,
    "Zinc (mg)": 0.05,
    "Copper (mg)": 0.03,
    "Vitamin A (IU)": 54.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 0.2,
    "Thiamine (B1) (mg)": 0.02,
    "Riboflavin (B2) (mg)": 0.03,
    "Niacin (B3) (mg)": 0.1,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 0.01,
    "Alpha-Linolenic Acid (g)": 0.01,
    "EPA + DHA (g)": 0.0
  },
  "Sunflower Oil": {
    "Calories (kcal)": 884.0,
    "Protein (g)": 0.0,
    "Fat (g)": 100.0,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 0.0,
    "Moisture (%)": 0.1,
    "Calcium (mg)": 0.0,
    "Phosphorus (mg)": 0.0,
    "Magnesium (mg)": 0.0,
    "Sodium (mg)": 0.0,
    "Potassium (mg)": 0.0,
    "Iron (mg)": 0.01,
    "Zinc (mg)": 0.01,
    "Copper (mg)": 0.0,
    "Vitamin A (IU)": 0.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 41.0,
    "Thiamine (B1) (mg)": 0.0,
    "Riboflavin (B2) (mg)": 0.0,
    "Niacin (B3) (mg)": 0.0,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 60.0,
    "Alpha-Linolenic Acid (g)": 0.3,
    "EPA + DHA (g)": 0.0
  },
  "Coconut Oil": {
    "Calories (kcal)": 862.0,
    "Protein (g)": 0.0,
    "Fat (g)": 100.0,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 0.0,
    "Moisture (%)": 0.1,
    "Calcium (mg)": 1.0,
    "Phosphorus (mg)": 0.0,
    "Magnesium (mg)": 0.0,
    "Sodium (mg)": 0.0,
    "Potassium (mg)": 0.0,
    "Iron (mg)": 0.04,
    "Zinc (mg)": 0.01,
    "Copper (mg)": 0.0,
    "Vitamin A (IU)": 0.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 0.3,
    "Thiamine (B1) (mg)": 0.0,
    "Riboflavin (B2) (mg)": 0.0,
    "Niacin (B3) (mg)": 0.0,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 2.0,
    "Alpha-Linolenic Acid (g)": 0.01,
    "EPA + DHA (g)": 0.0
  },
  "Toor Dal (boiled)": {
    "Calories (kcal)": 110.0,
    "Protein (g)": 7.2,
    "Fat (g)": 1.0,
    "Fibre (g)": 3.8,
    "Carbohydrate (g)": 19.4,
    "Moisture (%)": 65.0,
    "Calcium (mg)": 27.0,
    "Phosphorus (mg)": 114.0,
    "Magnesium (mg)": 42.0,
    "Sodium (mg)": 15.0,
    "Potassium (mg)": 210.0,
    "Iron (mg)": 1.3,
    "Zinc (mg)": 1.0,
    "Copper (mg)": 0.2,
    "Vitamin A (IU)": 50.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 0.2,
    "Thiamine (B1) (mg)": 0.2,
    "Riboflavin (B2) (mg)": 0.1,
    "Niacin (B3) (mg)": 1.4,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 0.04,
    "Alpha-Linolenic Acid (g)": 0.01,
    "EPA + DHA (g)": 0.0
  },
  "Fish (Rohu, cooked)": {
    "Calories (kcal)": 131.0,
    "Protein (g)": 22.0,
    "Fat (g)": 4.0,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 0.0,
    "Moisture (%)": 71.0,
    "Calcium (mg)": 70.0,
    "Phosphorus (mg)": 200.0,
    "Magnesium (mg)": 30.0,
    "Sodium (mg)": 50.0,
    "Potassium (mg)": 310.0,
    "Iron (mg)": 1.0,
    "Zinc (mg)": 1.0,
    "Copper (mg)": 0.1,
    "Vitamin A (IU)": 100.0,
    "Vitamin D (IU)": 90.0,
    "Vitamin E (mg)": 0.5,
    "Thiamine (B1) (mg)": 0.1,
    "Riboflavin (B2) (mg)": 0.1,
    "Niacin (B3) (mg)": 2.0,
    "Vitamin B12 (micro-g)": 1.2,
    "Linoleic Acid (g)": 0.2,
    "Alpha-Linolenic Acid (g)": 0.02,
    "EPA + DHA (g)": 0.4
  },
  "Chicken, cooked (boneless)": {
    "Calories (kcal)": 165.0,
    "Protein (g)": 31.0,
    "Fat (g)": 3.6,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 0.0,
    "Moisture (%)": 65.3,
    "Calcium (mg)": 15.0,
    "Phosphorus (mg)": 210.0,
    "Magnesium (mg)": 28.0,
    "Sodium (mg)": 70.0,
    "Potassium (mg)": 256.0,
    "Iron (mg)": 1.3,
    "Zinc (mg)": 1.0,
    "Copper (mg)": 0.04,
    "Vitamin A (IU)": 13.0,
    "Vitamin D (IU)": 5.0,
    "Vitamin E (mg)": 0.27,
    "Thiamine (B1) (mg)": 0.07,
    "Riboflavin (B2) (mg)": 0.1,
    "Niacin (B3) (mg)": 13.4,
    "Vitamin B12 (micro-g)": 0.3,
    "Linoleic Acid (g)": 0.4,
    "Alpha-Linolenic Acid (g)": 0.01,
    "EPA + DHA (g)": 0.05
  },
  "Rice, white (cooked)": {
    "Calories (kcal)": 130.0,
    "Protein (g)": 2.7,
    "Fat (g)": 0.3,
    "Fibre (g)": 0.3,
    "Carbohydrate (g)": 28.2,
    "Moisture (%)": 68.4,
    "Calcium (mg)": 10.0,
    "Phosphorus (mg)": 35.0,
    "Magnesium (mg)": 13.0,
    "Sodium (mg)": 1.0,
    "Potassium (mg)": 26.0,
    "Iron (mg)": 0.2,
    "Zinc (mg)": 0.5,
    "Copper (mg)": 0.07,
    "Vitamin A (IU)": 0.0,
    "Vitamin D (IU)": 0.0,
    "Vitamin E (mg)": 0.1,
    "Thiamine (B1) (mg)": 0.02,
    "Riboflavin (B2) (mg)": 0.02,
    "Niacin (B3) (mg)": 0.4,
    "Vitamin B12 (micro-g)": 0.0,
    "Linoleic Acid (g)": 0.1,
    "Alpha-Linolenic Acid (g)": 0.0,
    "EPA + DHA (g)": 0.0
  },
  "Paneer (homemade, whole milk)": {
    "Calories (kcal)": 265.0,
    "Protein (g)": 18.3,
    "Fat (g)": 20.8,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 1.2,
    "Moisture (%)": 54.0,
    "Calcium (mg)": 480.0,
    "Phosphorus (mg)": 310.0,
    "Magnesium (mg)": 21.0,
    "Sodium (mg)": 22.0,
    "Potassium (mg)": 95.0,
    "Iron (mg)": 0.2,
    "Zinc (mg)": 1.2,
    "Copper (mg)": 0.04,
    "Vitamin A (IU)": 210.0,
    "Vitamin D (IU)": 8.0,
    "Vitamin E (mg)": 0.2,
    "Thiamine (B1) (mg)": 0.05,
    "Riboflavin (B2) (mg)": 0.17,
    "Niacin (B3) (mg)": 0.2,
    "Vitamin B12 (micro-g)": 0.5,
    "Linoleic Acid (g)": 0.65,
    "Alpha-Linolenic Acid (g)": 0.05,
    "EPA + DHA (g)": 0.0
  },
  "Boiled Egg (whole)": {
    "Calories (kcal)": 155.0,
    "Protein (g)": 13.0,
    "Fat (g)": 11.0,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 1.1,
    "Moisture (%)": 76.0,
    "Calcium (mg)": 50.0,
    "Phosphorus (mg)": 86.0,
    "Magnesium (mg)": 10.0,
    "Sodium (mg)": 124.0,
    "Potassium (mg)": 126.0,
    "Iron (mg)": 1.2,
    "Zinc (mg)": 1.0,
    "Copper (mg)": 0.04,
    "Vitamin A (IU)": 540.0,
    "Vitamin D (IU)": 87.0,
    "Vitamin E (mg)": 1.0,
    "Thiamine (B1) (mg)": 0.03,
    "Riboflavin (B2) (mg)": 0.51,
    "Niacin (B3) (mg)": 0.1,
    "Vitamin B12 (micro-g)": 1.1,
    "Linoleic Acid (g)": 1.8,
    "Alpha-Linolenic Acid (g)": 0.1,
    "EPA + DHA (g)": 0.05
  },
  "Curd (homemade, full fat)": {
    "Calories (kcal)": 98.0,
    "Protein (g)": 3.5,
    "Fat (g)": 4.3,
    "Fibre (g)": 0.0,
    "Carbohydrate (g)": 3.0,
    "Moisture (%)": 85.0,
    "Calcium (mg)": 120.0,
    "Phosphorus (mg)": 90.0,
    "Magnesium (mg)": 12.0,
    "Sodium (mg)": 36.0,
    "Potassium (mg)": 155.0,
    "Iron (mg)": 0.2,
    "Zinc (mg)": 0.6,
    "Copper (mg)": 0.02,
    "Vitamin A (IU)": 120.0,
    "Vitamin D (IU)": 5.0,
    "Vitamin E (mg)": 0.1,
    "Thiamine (B1) (mg)": 0.04,
    "Riboflavin (B2) (mg)": 0.12,
    "Niacin (B3) (mg)": 0.1,
    "Vitamin B12 (micro-g)": 0.4,
    "Linoleic Acid (g)": 0.2,
    "Alpha-Linolenic Acid (g)": 0.03,
    "EPA + DHA (g)": 0.0
  },
  "Pedigree Adult Chicken Gravy": {
    "Calories (kcal)": 68.0,
    "Protein (g)": 8.0,
    "Fat (g)": 4.0,
    "Fibre (g)": 3.0,
    "Carbohydrate (g)": 0.0,
    "Moisture (%)": 85.0
  },
  "Drools Adult Chicken Gravy": {
    "Calories (kcal)": 94.0,
    "Protein (g)": 10.0,
    "Fat (g)": 6.0,
    "Fibre (g)": 2.0,
    "Carbohydrate (g)": 0.0,
    "Moisture (%)": 82.0
  },
  "Kennel Kitchen Adult Fish Gravy": {
    "Calories (kcal)": 115.0,
    "Protein (g)": 10.0,
    "Fat (g)": 5.0,
    "Fibre (g)": 1.0,
    "Carbohydrate (g)": 8.0,
    "Moisture (%)": 76.0
  },
  "Kennel Kitchen Adult Lamb Gravy": {
    "Calories (kcal)": 148.7,
    "Protein (g)": 12.2,
    "Fat (g)": 6.4,
    "Fibre (g)": 0.12,
    "Carbohydrate (g)": 11.28,
    "Moisture (%)": 70.0
  },
  "Kennel Kitchen Adult Chicken Gravy": {
    "Calories (kcal)": 138.4,
    "Protein (g)": 14.25,
    "Fat (g)": 7.92,
    "Fibre (g)": 0.3,
    "Carbohydrate (g)": 2.7,
    "Moisture (%)": 74.83
  },
  "Drools Adult chicken and egg Kibble": {
    "Calories (kcal)": 138.4,
    "Protein (g)": 14.25,
    "Fat (g)": 7.92,
    "Fibre (g)": 0.3,
    "Carbohydrate (g)": 2.7,
    "Moisture (%)": 74.83
  },
  "Focus Adult Chicken Dry Kibble": {
    "Calories (kcal)": 380.0,
    "Protein (g)": 20.0,
    "Fat (g)": 10.0,
    "Fibre (g)": 4.0,
    "Carbohydrate (g)": 56.0,
    "Moisture (%)": 10.0
  },
  "Pedigree Pro Adult Chicken Kibble": {
    "Calories (kcal)": 419.0,
    "Protein (g)": 28.0,
    "Fat (g)": 16.0,
    "Fibre (g)": 2.5,
    "Carbohydrate (g)": 43.5,
    "Moisture (%)": 10.0
  },
  "Pedigree Adult chicken and rice Kibble": {
    "Calories (kcal)": 386.0,
    "Protein (g)": 28.0,
    "Fat (g)": 15.0,
    "Fibre (g)": 5.0,
    "Carbohydrate (g)": 37.0,
    "Moisture (%)": 15.0
  },
  "Royal Canin Adult Chicken Kibble": {
    "Calories (kcal)": 350.0,
    "Protein (g)": 20.0,
    "Fat (g)": 10.0,
    "Fibre (g)": 5.0,
    "Carbohydrate (g)": 48.0,
    "Moisture (%)": 17.0
  },
  "Amalgo Chicken and Rice Ready to Eat": {
    "Calories (kcal)": 147.0,
    "Protein (g)": 7.0,
    "Fat (g)": 7.0,
    "Fibre (g)": 1.0,
    "Carbohydrate (g)": 15.0,
    "Moisture (%)": 70.0
  }
};